var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-carousel',{attrs:{"after-change":_vm.onChange}},[_c('div',[_c('img',{attrs:{"width":"100%","src":"https://hxh-1305060147.cos.ap-chengdu.myqcloud.com/bAdmin/login/bg.png","alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }